export default __webpack_public_path__ + "images/0x63468133ed352e602beb61dd254d6060ad2fe419.png";